import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { SubscriptionGateService } from '../services/subscription-gate.service';
import { BillingService } from '../services/billing.service';
import { AuthStateService } from '../auth/auth-state.service';

/**
 * When showBilling is on, unpaid client users opening rates go to Billing.
 * When showBilling is off, no check — features are free.
 */
export const subscriptionAccessGuard: CanActivateFn = () => {
  const gate = inject(SubscriptionGateService);
  const billing = inject(BillingService);
  const auth = inject(AuthStateService);
  const router = inject(Router);

  if (!gate.isClientBillingEnabled() || auth.isITStaff()) {
    return true;
  }

  return billing.getStatus().pipe(
    map((s) =>
      gate.isSubscriptionOk(s.status)
        ? true
        : router.createUrlTree(['/app/billing'])
    ),
    catchError(() => of(router.createUrlTree(['/app/billing'])))
  );
};
